export default __webpack_public_path__ + "static/media/fast_dark.65eff049.svg";